module.exports = __webpack_public_path__ + "static/media/background_img3.4b96aa96.png";